import React, { useState } from "react";
import "./Rating_Review.css";

import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faXmark,
  faStar as solidStar,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";


import { useDispatch } from "react-redux";
import { postRating } from "../../../../../features/rating/ratingSlice";
import { getOrder } from "../../../../../features/order/orderSlice";
import Blue_Btn from "../../../../common_components/common_btn/Blue_Btn/Blue_Btn";
import Gray_Btn from "../../../../common_components/common_btn/gray_btn/Gray_Btn";
import Success_Modal from "../../../../common_components/common_modal/success_modal/Success_Modal";

const Rating_Review = ({setShowReviewRating, order, setProductId, productId }) => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const dispatch = useDispatch();
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      ratings: 1,
    },
  });

  const handleStarClick = (starIndex) => {
    const newRatings = [...ratings];
    var rate = 1;
    for (let i = 0; i < newRatings.length; i++) {
      newRatings[i] = i < starIndex ? 1 : 0;
    }
    newRatings?.map((value, index) => {
      if (value == 1) {
        rate = index + 1;
      }
    });

    setRatings(newRatings);
    setValue("ratings", rate);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles([...selectedFiles, ...files]);
    setValue("files", files);
  };

  const handleRemoveImage = (index) => {
    const filteredFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(filteredFiles);
  };

  const [ratings, setRatings] = useState([1, 0, 0, 0, 0]);

  const renderStars = () => {
    return ratings.map((rating, index) => (
      <FontAwesomeIcon
        key={index}
        icon={rating === 1 ? solidStar : regularStar}
        className="star-icon me-1"
        onClick={() => handleStarClick(index + 1)}
      />
    ));
  };

  const nevigate = useNavigate();

  const onSubmit = async (d) => {
    const DataToSend = new FormData();
    DataToSend.append("ratings", d.ratings);
    DataToSend.append("review", d.review);
    DataToSend.append("product_id", productId);
    DataToSend.append("order_id", order?.id);

    // if (selectedFiles.length > 0) {
    //     selectedFiles?.map((image, index) => {
    //         console.log(image, 'imageimage');

    //         DataToSend.append(`image[${index}]`, image[index]);
    //     });
    // }

    if (selectedFiles && selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        DataToSend.append("images", selectedFiles[i]);
      }
    }
    // DataToSend.append("files", d?.files[0]);

    const data = {
      ratings: d.ratings,
      review: d.review,
      files: d.files,
      product_id: productId,
      order_id: order?.id,
    };
    const res = await dispatch(postRating(DataToSend));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        nevigate("/my-orders");
      }, 3000);
      await dispatch(getOrder(order?.id));
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  return (
    <div className="Rating_Review">
      <div className="heading_question">
        <p className="title">Add Ratings and Review</p>
        <div className="rating_div">
          <div className="">{renderStars()}</div>
          {errors.ratings && (
            <div className="text-danger">{errors.ratings.message}</div>
          )}
        </div>
      </div>

      <div className="rating pt-3">
        <p className="add_text">Add Images / Videos</p>
        <div className="two_content_holder">
          <Form.Label className="plus-btn">
            <FontAwesomeIcon icon={faPlus} />
            <Form.Control
              name="files"
              type="file"
              onChange={handleFileChange}
              multiple
              accept="image/*,video/*"
            />
          </Form.Label>
          <div className="image-holder">
            {selectedFiles.length > 0 &&
              selectedFiles.map((file, index) => (
                <div className="file-img-holder" key={index}>
                  <object
                    className="img-logo"
                    data={URL.createObjectURL(file)}
                    type={file.type}
                    width="59" // Set the width
                    height="58" // Set the height
                  />
                  <div
                    className="cross-overlay"
                    onClick={() => handleRemoveImage(index)}
                  >
                    <FontAwesomeIcon icon={faXmark} className="close_icon" />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      {errors.files && <p className="text-danger">{errors.files.message}</p>}

      <div className="textarea_div">
        <textarea
          name="review"
          placeholder="Type a product review here"
          {...register("review", {
            required: "Review is required",
          })}
        ></textarea>
      </div>
      {errors.review && <p className="text-danger">{errors.review.message}</p>}

      <div className="col-md-12">
        <div className="text-center btn_holder">
          <div className="">
            <Blue_Btn
              btnText="Submit"
              onClick={
                handleSubmit(onSubmit)
                // setShowSucsessModal(true)

                //     setTimeout(() => {
                //              setShowSucsessModal(false)
                //              navigate("/")
                //     }, 3000);
              }
            />
          </div>
          <div className="">
            <Gray_Btn
              btn_name="Cancel"
              onClick={() => {
                setShowReviewRating(false);
              }}
            />
          </div>
        </div>
      </div>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Review Added Succesffully !"
      />
    </div>
  );
};

export default Rating_Review;
